module.exports = __webpack_public_path__ + "img/Malaysia-4.195e6266.jpg";